<div class="top-bar position-fixed">
    <div class="row align-items-center">
        <div class="col-2">
            <img *ngIf="logoSrc" [src]="logoSrc" alt="Logo" class="platform-logo" />
        </div>
    </div>
</div>
